module.exports = __webpack_public_path__ + "img/ultra_1_04.281f73b9.jpg";